import React from "react";
import cx from "classnames";
import s from "./servicesRecapTable.scss";
import _ from "lodash";

const ServicesRecapTable = ({ tableName, servicesData = [], className }) => {
  return (
    <div className={cx("inputFull2", s.bill, className)}>
      <div className={cx(s.headerService, s.rowService)}>
        <div className={s.nameService}> {tableName}</div>
      </div>

      {_.compact(servicesData).map((service) => (
        <div key={service.name} className={s.rowService}>
          <div className={s.nameService}>{service.name}</div>
          <div className={s.dataService}>
            <div className={s.serviceValue}>{service.value}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ServicesRecapTable;
